/* Nordicsheep gift ladder: 2+ items = free brush (NCL1308), 3+ items = free care kit (NCF1400-1).
   Kategori-varer (EXCLUDE_TYPE) taeller MED i trappen ved 1-5 stk; ved 6+ opbruger 6-for-5-rabatten enhederne. 4+ varer = 10% ordre-rabat (Automatic, styres ikke her). */
(function () {
  var TIERS = [
    { min: 3, variant: 51148585369946 },
    { min: 2, variant: 49600268042586 }
  ];
  var GIFT_VARIANTS = [51148585369946, 49600268042586];
  var EXCLUDE_TYPE = 'Seat Covers';
  var EXCLUDE_TITLE = /a^/;
  var PROP = '_free_gift';
  var busy = false;

  function isExcluded(it) {
    return it.product_type === EXCLUDE_TYPE || EXCLUDE_TITLE.test(it.product_title || '');
  }

  function cartState(cart) {
    var giftLines = [], nonGiftQty = 0, hyndeQty = 0, variantPresent = {};
    (cart.items || []).forEach(function (it) {
      variantPresent[it.variant_id] = true;
      if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1 && it.properties && it.properties[PROP]) giftLines.push(it);
      else if (isExcluded(it)) hyndeQty += it.quantity;
      else nonGiftQty += it.quantity;
    });
    if (hyndeQty > 0 && hyndeQty < 6) nonGiftQty += hyndeQty;
    return { giftLines: giftLines, nonGiftQty: nonGiftQty, variantPresent: variantPresent };
  }

  function refreshUI(sectionsJson) {
    try {
      if (window.general && general.template === 'cart') { window.location.reload(); return; }
      var aside = document.getElementById('cart');
      if (aside && window.ajaxCart && ajaxCart.load) {
        var open = aside.getAttribute('aria-hidden') === 'false';
        if (sectionsJson && sectionsJson.sections && sectionsJson.sections['side-cart']) {
          ajaxCart.load(sectionsJson, open);
        } else {
          ajaxCart.load(false, open, false, true);
        }
      }
    } catch (e) { console.log('ns-gift refreshUI', e); }
  }

  function mutate(url, payload) {
    return fetch(url + '?ns_gift=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js?ns_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart);
      var target = null;
      for (var i = 0; i < TIERS.length; i++) { if (st.nonGiftQty >= TIERS[i].min) { target = TIERS[i]; break; } }

      var dismissedVar = sessionStorage.getItem('nsGiftDismissed') || '';
      var prevTier = sessionStorage.getItem('nsGiftTier') || '';

      if (target && prevTier === String(target.variant) && st.giftLines.length === 0 && !st.variantPresent[target.variant]) {
        sessionStorage.setItem('nsGiftDismissed', String(target.variant));
        dismissedVar = String(target.variant);
      }
      if (!target) { sessionStorage.removeItem('nsGiftDismissed'); dismissedVar = ''; }
      var dismissed = target && dismissedVar === String(target.variant);

      var ops = [];
      st.giftLines.forEach(function (gl) {
        if (!target || gl.variant_id !== target.variant) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });
      var needAdd = target && !st.variantPresent[target.variant] && !dismissed;

      var chain = Promise.resolve(null);
      ops.forEach(function (op) {
        chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); });
      });
      if (needAdd) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: target.variant, quantity: 1, properties: props, sections: 'side-cart' });
        }).then(function (json) {
          if (!json) {
            for (var j = 0; j < TIERS.length; j++) {
              var t = TIERS[j];
              if (t.variant !== target.variant && st.nonGiftQty >= t.min && !st.variantPresent[t.variant]) {
                var props2 = {}; props2[PROP] = '1';
                return mutate('/cart/add.js', { id: t.variant, quantity: 1, properties: props2, sections: 'side-cart' });
              }
            }
          }
          return json;
        });
      } else if (ops.length) {
        chain = chain.then(function () { return mutate('/cart/update.js', { sections: 'side-cart' }); });
      }

      chain.then(function (json) {
        sessionStorage.setItem('nsGiftTier', target ? String(target.variant) : '');
        if (ops.length || needAdd) refreshUI(json);
        busy = false;
      }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (CART_MUTATION.test(url) && url.indexOf('ns_gift=1') === -1) {
        p.then(function () { setTimeout(reconcile, 150); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsGiftUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try {
      var u = this.__nsGiftUrl || '';
      if (CART_MUTATION.test(u) && u.indexOf('ns_gift=1') === -1) {
        this.addEventListener('load', function () { setTimeout(reconcile, 150); });
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  /* Quick-add knapper (.ns-quickadd med data-variant) fra ns-gift-promo: virker globalt, ogsaa i AJAX-injectet drawer-HTML */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ns-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v) return;
    if (b.classList.contains('ns-qa-busy')) return;
    b.classList.add('ns-qa-busy');
    mutate('/cart/add.js', { id: v, quantity: 1, sections: 'side-cart' }).then(function (json) {
      b.classList.remove('ns-qa-busy');
      if (json) { refreshUI(json); setTimeout(reconcile, 200); }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 300); });
  } else {
    setTimeout(reconcile, 300);
  }
})();
